import DummyRouter from '@/features/ui/components/DummyRouter.vue'
import { useAppEnvironmentMode } from '@/features/environment/useAppEnvironmentMode.js'
import { createNoAccessPath } from '@/features/noAccess/noAccess.utils.js'
import {
  SuperAdminLimitedLogsViewActions,
  SuperAdminLimitedOASystemNavigationActions,
} from '@/features/superAdmin/superAdminLimitedPermissionActions.js'

const { isUat2Mode } = useAppEnvironmentMode()

export const superAdminLogsManagementRoutes = [
  {
    path: 'logs',
    component: DummyRouter,
    meta: {
      permissionAnyActions: SuperAdminLimitedLogsViewActions,
    },
    children: [
      {
        path: '',
        component: () => import('./SuperAdminLogsView.vue'),
        meta: {
          permissionAnyActions: SuperAdminLimitedLogsViewActions,
        },
      },
    ],
  },
  {
    path: 'oa-system',
    beforeEnter: to => {
      if (isUat2Mode) return true

      return createNoAccessPath({
        reason: 'permission-denied',
        action: SuperAdminLimitedOASystemNavigationActions[0],
        returnUrl: to.fullPath,
      })
    },
    component: () => import('./oaSystem/SuperAdminLogsViewOASystem.vue'),
    meta: {
      permissionAnyActions: SuperAdminLimitedOASystemNavigationActions,
    },
  },
]
